var map = {
	"./BActions.json": "ccd1",
	"./BFactory.json": "f0e2",
	"./BPool.json": "f703",
	"./BountyNFT.json": "644d",
	"./BuniBounty.json": "cb17",
	"./BuniCornFactory.json": "d091",
	"./BuniCornPool.json": "ba0c",
	"./BuniCornRouter02.json": "4e7c",
	"./BuniPool.json": "b7ad",
	"./BuniPoolFactory.json": "a3ca5",
	"./BuniSyrupPool.json": "33c0",
	"./BuniUniversalV2.json": "1fe3",
	"./BunicornsV2.json": "8cfa",
	"./CRPFactory.json": "5ce6",
	"./ConfigurableRightsPool.json": "2401",
	"./DSProxy.json": "68ad",
	"./DSProxyRegistry.json": "318e",
	"./ERC20.json": "e198",
	"./ExchangeProxy.json": "6ba0",
	"./ExchangeProxyCallable.json": "ebe9",
	"./GameNFTStakingRewardsUpgradeable.json": "7a16",
	"./Governance.json": "3b8b",
	"./LPErc20.json": "0a28",
	"./MasterChef.json": "9da8",
	"./Multicall.json": "29eb",
	"./MysteryBox.json": "86c9",
	"./RewardTokenFarm.json": "ddb5",
	"./StakingReward.json": "9682",
	"./StakingRewardFactory.json": "9028",
	"./TestToken.json": "8d51",
	"./TokenFarmMasterChef.json": "959f",
	"./TrainersV2.json": "e9e8",
	"./VBuni.json": "1a4a",
	"./VBuniNFTFarm.json": "30e7",
	"./VBuniNFTFarmNew.json": "ae99",
	"./Weth.json": "53bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be09";